var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlanDetailIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plan Details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Installer-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company-settings-copy",
    transform: "translate(-38.000000, -196.000000)",
    fill: "#00142D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(38.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4854",
    points: "11.4332 4.79808 8.8516 7.38048 12.1612 10.00288 14.4004 7.76528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0484,16.48672 L8.1172,7.81872 C7.8684,8.39072 7.1628,9.33792 6.422,9.72592 L16.5284,19.09312 C16.602,19.16272 16.6876,19.20032 16.7996,19.20032 C17.9004,19.20032 18.45,19.20032 18.8692,18.58352 C19.2708,17.99232 19.2044,17.22432 19.1996,16.80032 C19.1988,16.67792 19.1444,16.56272 19.0484,16.48672",
    id: "Fill-4855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63904,5.7 C7.51424,4.8416 7.06784,4.0872 6.38304,3.5768 C5.99104,3.2848 5.49504,3.1264 4.97104,2.96 C3.75824,2.5744 2.71024,2.2416 2.79984,0.4192 C2.80784,0.256 2.71424,0.104 2.56544,0.0352 C2.41664,-0.0312 2.24064,-0.0016 2.12224,0.1128 C0.39824,1.7792 -0.09616,4.0968 0.79904,6.3112 C1.54384,8.1528 3.11424,9.4384 4.61824,9.4384 C5.26544,9.4384 6.21024,9.2056 7.03904,8.0944 C7.55104,7.4096 7.76384,6.5592 7.63904,5.7",
    id: "Fill-4856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2328,17.72968 L1.4696,15.96728 L0.9176,16.51688 C0.7624,16.67448 0.7616,16.92728 0.9176,17.08248 L1.236,17.40088 L0.1192,18.51848 C-0.0376,18.67528 -0.0408,18.92408 0.1168,19.08248 C0.2752,19.24088 0.524,19.23688 0.6808,19.07928 L1.7984,17.96248 L2.1168,18.28088 C2.2728,18.43768 2.5256,18.43768 2.6824,18.28088 L3.2328,17.72968 Z",
    id: "Fill-4857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8996,10.33168 L1.7164,14.51568 C1.5596,14.67248 1.5596,14.92528 1.7164,15.08128 L4.1172,17.48128 C4.2732,17.63728 4.526,17.63728 4.6828,17.48128 L8.978,13.18608 L5.8996,10.33168 Z",
    id: "Fill-4858"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4859",
    points: "12.16096 10.00312 14.39936 7.76632 11.43216 4.79912 8.85136 7.37992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.082,2.5172 L16.682,0.1172 C16.5252,-0.0388 16.2732,-0.0388 16.1172,0.1172 L11.9996,4.234 L14.9652,7.2004 L17.942,4.222 C18.0212,4.3972 18.0676,4.5924 18.0676,4.8004 C18.0676,5.1596 17.9396,5.494 17.7164,5.7172 L13.7164,9.7172 C13.5604,9.8732 13.5604,10.1268 13.7164,10.2828 L13.7172,10.2828 C13.8724,10.4388 14.126,10.4388 14.282,10.2828 L18.282,6.2828 C18.654,5.91 18.8684,5.37 18.8676,4.8004 C18.8684,4.3748 18.7484,3.9652 18.5332,3.6316 L19.082,3.0828 C19.238,2.9268 19.238,2.6724 19.082,2.5172",
    id: "Fill-4860"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlanDetailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/planDetail_icon.939271613131407ba64a1cd5c12ef69c.svg";